// Full airport database — 200+ airports across Europe and popular international destinations
export const AIRPORT_DB = {
  // === NETHERLANDS ===
  AMS: { city: 'Amsterdam',               flag: '🇳🇱' },
  RTM: { city: 'Rotterdam',               flag: '🇳🇱' },
  EIN: { city: 'Eindhoven',               flag: '🇳🇱' },

  // === UNITED KINGDOM ===
  LHR: { city: 'London Heathrow',         flag: '🇬🇧' },
  LGW: { city: 'London Gatwick',          flag: '🇬🇧' },
  STN: { city: 'London Stansted',         flag: '🇬🇧' },
  LTN: { city: 'London Luton',            flag: '🇬🇧' },
  SEN: { city: 'London Southend',         flag: '🇬🇧' },
  MAN: { city: 'Manchester',              flag: '🇬🇧' },
  BHX: { city: 'Birmingham',              flag: '🇬🇧' },
  BRS: { city: 'Bristol',                 flag: '🇬🇧' },
  LPL: { city: 'Liverpool',               flag: '🇬🇧' },
  NCL: { city: 'Newcastle',               flag: '🇬🇧' },
  LBA: { city: 'Leeds Bradford',          flag: '🇬🇧' },
  EMA: { city: 'East Midlands',           flag: '🇬🇧' },
  DSA: { city: 'Doncaster',               flag: '🇬🇧' },
  EDI: { city: 'Edinburgh',               flag: '🇬🇧' },
  GLA: { city: 'Glasgow',                 flag: '🇬🇧' },
  ABZ: { city: 'Aberdeen',                flag: '🇬🇧' },
  INV: { city: 'Inverness',               flag: '🇬🇧' },
  CWL: { city: 'Cardiff',                 flag: '🇬🇧' },
  BFS: { city: 'Belfast',                 flag: '🇬🇧' },
  JER: { city: 'Jersey',                  flag: '🇬🇧' },
  IOM: { city: 'Isle of Man',             flag: '🇬🇧' },

  // === IRELAND ===
  DUB: { city: 'Dublin',                  flag: '🇮🇪' },
  ORK: { city: 'Cork',                    flag: '🇮🇪' },
  SNN: { city: 'Shannon',                 flag: '🇮🇪' },
  KIR: { city: 'Kerry',                   flag: '🇮🇪' },

  // === FRANCE ===
  CDG: { city: 'Paris Charles de Gaulle', flag: '🇫🇷' },
  ORY: { city: 'Paris Orly',             flag: '🇫🇷' },
  LYS: { city: 'Lyon',                    flag: '🇫🇷' },
  NCE: { city: 'Nice',                    flag: '🇫🇷' },
  MRS: { city: 'Marseille',               flag: '🇫🇷' },
  TLS: { city: 'Toulouse',                flag: '🇫🇷' },
  BOD: { city: 'Bordeaux',                flag: '🇫🇷' },
  NTE: { city: 'Nantes',                  flag: '🇫🇷' },
  SXB: { city: 'Strasbourg',              flag: '🇫🇷' },
  LIL: { city: 'Lille',                   flag: '🇫🇷' },
  MPL: { city: 'Montpellier',             flag: '🇫🇷' },
  RNS: { city: 'Rennes',                  flag: '🇫🇷' },
  BIQ: { city: 'Biarritz',               flag: '🇫🇷' },
  AJA: { city: 'Ajaccio',                 flag: '🇫🇷' },
  BIA: { city: 'Bastia',                  flag: '🇫🇷' },
  FSC: { city: 'Figari',                  flag: '🇫🇷' },

  // === BELGIUM ===
  BRU: { city: 'Brussels',                flag: '🇧🇪' },
  CRL: { city: 'Brussels South',          flag: '🇧🇪' },
  LGG: { city: 'Liège',                   flag: '🇧🇪' },

  // === LUXEMBOURG ===
  LUX: { city: 'Luxembourg',              flag: '🇱🇺' },

  // === GERMANY ===
  FRA: { city: 'Frankfurt',               flag: '🇩🇪' },
  MUC: { city: 'Munich',                  flag: '🇩🇪' },
  DUS: { city: 'Düsseldorf',             flag: '🇩🇪' },
  BER: { city: 'Berlin',                  flag: '🇩🇪' },
  HAM: { city: 'Hamburg',                 flag: '🇩🇪' },
  STR: { city: 'Stuttgart',               flag: '🇩🇪' },
  CGN: { city: 'Cologne',                 flag: '🇩🇪' },
  QKL: { city: 'Cologne',                 flag: '🇩🇪' },
  NUE: { city: 'Nuremberg',               flag: '🇩🇪' },
  HAJ: { city: 'Hanover',                 flag: '🇩🇪' },
  BRE: { city: 'Bremen',                  flag: '🇩🇪' },
  LEJ: { city: 'Leipzig',                 flag: '🇩🇪' },
  DRS: { city: 'Dresden',                 flag: '🇩🇪' },
  ERF: { city: 'Erfurt',                  flag: '🇩🇪' },
  FMM: { city: 'Memmingen',               flag: '🇩🇪' },
  SCN: { city: 'Saarbrücken',            flag: '🇩🇪' },
  HHN: { city: 'Frankfurt Hahn',          flag: '🇩🇪' },
  DTM: { city: 'Dortmund',                flag: '🇩🇪' },
  PAD: { city: 'Paderborn',               flag: '🇩🇪' },

  // === SWITZERLAND ===
  ZRH: { city: 'Zurich',                  flag: '🇨🇭' },
  GVA: { city: 'Geneva',                  flag: '🇨🇭' },
  BSL: { city: 'Basel',                   flag: '🇨🇭' },

  // === AUSTRIA ===
  VIE: { city: 'Vienna',                  flag: '🇦🇹' },
  SZG: { city: 'Salzburg',                flag: '🇦🇹' },
  INN: { city: 'Innsbruck',               flag: '🇦🇹' },
  GRZ: { city: 'Graz',                    flag: '🇦🇹' },
  LNZ: { city: 'Linz',                    flag: '🇦🇹' },

  // === SPAIN ===
  MAD: { city: 'Madrid',                  flag: '🇪🇸' },
  BCN: { city: 'Barcelona',               flag: '🇪🇸' },
  PMI: { city: 'Palma de Mallorca',       flag: '🇪🇸' },
  AGP: { city: 'Málaga',                 flag: '🇪🇸' },
  ALC: { city: 'Alicante',                flag: '🇪🇸' },
  VLC: { city: 'Valencia',                flag: '🇪🇸' },
  SVQ: { city: 'Seville',                 flag: '🇪🇸' },
  XQA: { city: 'Seville',                 flag: '🇪🇸' },
  BIO: { city: 'Bilbao',                  flag: '🇪🇸' },
  IBZ: { city: 'Ibiza',                   flag: '🇪🇸' },
  ACE: { city: 'Lanzarote',               flag: '🇪🇸' },
  TFS: { city: 'Tenerife South',          flag: '🇪🇸' },
  TFN: { city: 'Tenerife North',          flag: '🇪🇸' },
  LPA: { city: 'Las Palmas',              flag: '🇪🇸' },
  FUE: { city: 'Fuerteventura',           flag: '🇪🇸' },
  MAH: { city: 'Menorca',                 flag: '🇪🇸' },
  VGO: { city: 'Vigo',                    flag: '🇪🇸' },
  OVD: { city: 'Asturias',                flag: '🇪🇸' },
  SCQ: { city: 'Santiago de Compostela',  flag: '🇪🇸' },
  SDR: { city: 'Santander',               flag: '🇪🇸' },
  MJV: { city: 'Murcia',                  flag: '🇪🇸' },
  GRX: { city: 'Granada',                 flag: '🇪🇸' },
  SPC: { city: 'La Palma',                flag: '🇪🇸' },
  ZAZ: { city: 'Zaragoza',                flag: '🇪🇸' },

  // === PORTUGAL ===
  LIS: { city: 'Lisbon',                  flag: '🇵🇹' },
  OPO: { city: 'Porto',                   flag: '🇵🇹' },
  FAO: { city: 'Faro',                    flag: '🇵🇹' },
  FNC: { city: 'Funchal',                 flag: '🇵🇹' },
  PDL: { city: 'Ponta Delgada',           flag: '🇵🇹' },

  // === ITALY ===
  FCO: { city: 'Rome',                    flag: '🇮🇹' },
  MXP: { city: 'Milan Malpensa',          flag: '🇮🇹' },
  LIN: { city: 'Milan Linate',            flag: '🇮🇹' },
  BGY: { city: 'Milan Bergamo',           flag: '🇮🇹' },
  VCE: { city: 'Venice',                  flag: '🇮🇹' },
  VRN: { city: 'Verona',                  flag: '🇮🇹' },
  NAP: { city: 'Naples',                  flag: '🇮🇹' },
  CTA: { city: 'Catania',                 flag: '🇮🇹' },
  PMO: { city: 'Palermo',                 flag: '🇮🇹' },
  BLQ: { city: 'Bologna',                 flag: '🇮🇹' },
  FLR: { city: 'Florence',                flag: '🇮🇹' },
  PSA: { city: 'Pisa',                    flag: '🇮🇹' },
  TRN: { city: 'Turin',                   flag: '🇮🇹' },
  BRI: { city: 'Bari',                    flag: '🇮🇹' },
  CAG: { city: 'Cagliari',                flag: '🇮🇹' },
  GOA: { city: 'Genoa',                   flag: '🇮🇹' },
  TRS: { city: 'Trieste',                 flag: '🇮🇹' },
  AOI: { city: 'Ancona',                  flag: '🇮🇹' },
  RMI: { city: 'Rimini',                  flag: '🇮🇹' },
  REG: { city: 'Reggio Calabria',         flag: '🇮🇹' },
  SUF: { city: 'Lamezia Terme',           flag: '🇮🇹' },

  // === DENMARK ===
  CPH: { city: 'Copenhagen',              flag: '🇩🇰' },
  AAL: { city: 'Aalborg',                 flag: '🇩🇰' },
  BLL: { city: 'Billund',                 flag: '🇩🇰' },

  // === NORWAY ===
  OSL: { city: 'Oslo',                    flag: '🇳🇴' },
  BGO: { city: 'Bergen',                  flag: '🇳🇴' },
  SVG: { city: 'Stavanger',               flag: '🇳🇴' },
  TRD: { city: 'Trondheim',               flag: '🇳🇴' },
  TOS: { city: 'Tromsø',                 flag: '🇳🇴' },
  BOO: { city: 'Bodø',                   flag: '🇳🇴' },
  AES: { city: 'Ålesund',               flag: '🇳🇴' },
  KRS: { city: 'Kristiansand',            flag: '🇳🇴' },
  HAU: { city: 'Haugesund',               flag: '🇳🇴' },

  // === SWEDEN ===
  ARN: { city: 'Stockholm',               flag: '🇸🇪' },
  GOT: { city: 'Gothenburg',              flag: '🇸🇪' },
  MMX: { city: 'Malmö',                  flag: '🇸🇪' },
  LLA: { city: 'Luleå',                  flag: '🇸🇪' },
  UME: { city: 'Umeå',                   flag: '🇸🇪' },

  // === FINLAND ===
  HEL: { city: 'Helsinki',                flag: '🇫🇮' },
  TMP: { city: 'Tampere',                 flag: '🇫🇮' },
  OUL: { city: 'Oulu',                    flag: '🇫🇮' },
  TKU: { city: 'Turku',                   flag: '🇫🇮' },
  RVN: { city: 'Rovaniemi',               flag: '🇫🇮' },

  // === ICELAND ===
  KEF: { city: 'Reykjavik',               flag: '🇮🇸' },

  // === POLAND ===
  WAW: { city: 'Warsaw',                  flag: '🇵🇱' },
  WMI: { city: 'Warsaw Modlin',           flag: '🇵🇱' },
  KRK: { city: 'Kraków',                 flag: '🇵🇱' },
  GDN: { city: 'Gdańsk',                 flag: '🇵🇱' },
  WRO: { city: 'Wrocław',                flag: '🇵🇱' },
  POZ: { city: 'Poznań',                 flag: '🇵🇱' },
  KTW: { city: 'Katowice',                flag: '🇵🇱' },
  LCJ: { city: 'Łódź',                   flag: '🇵🇱' },

  // === CZECH REPUBLIC ===
  PRG: { city: 'Prague',                  flag: '🇨🇿' },
  BRQ: { city: 'Brno',                    flag: '🇨🇿' },

  // === SLOVAKIA ===
  BTS: { city: 'Bratislava',              flag: '🇸🇰' },
  KSC: { city: 'Košice',                 flag: '🇸🇰' },

  // === HUNGARY ===
  BUD: { city: 'Budapest',                flag: '🇭🇺' },
  DEB: { city: 'Debrecen',                flag: '🇭🇺' },

  // === ROMANIA ===
  OTP: { city: 'Bucharest',               flag: '🇷🇴' },
  CLJ: { city: 'Cluj-Napoca',             flag: '🇷🇴' },
  TSR: { city: 'Timișoara',              flag: '🇷🇴' },
  SBZ: { city: 'Sibiu',                   flag: '🇷🇴' },
  IAS: { city: 'Iași',                   flag: '🇷🇴' },

  // === BULGARIA ===
  SOF: { city: 'Sofia',                   flag: '🇧🇬' },
  VAR: { city: 'Varna',                   flag: '🇧🇬' },
  BOJ: { city: 'Burgas',                  flag: '🇧🇬' },

  // === SERBIA ===
  BEG: { city: 'Belgrade',                flag: '🇷🇸' },
  INI: { city: 'Niš',                    flag: '🇷🇸' },

  // === CROATIA ===
  ZAG: { city: 'Zagreb',                  flag: '🇭🇷' },
  SPU: { city: 'Split',                   flag: '🇭🇷' },
  DBV: { city: 'Dubrovnik',               flag: '🇭🇷' },
  ZAD: { city: 'Zadar',                   flag: '🇭🇷' },
  PUY: { city: 'Pula',                    flag: '🇭🇷' },
  RJK: { city: 'Rijeka',                  flag: '🇭🇷' },

  // === SLOVENIA ===
  LJU: { city: 'Ljubljana',               flag: '🇸🇮' },

  // === BOSNIA ===
  SJJ: { city: 'Sarajevo',                flag: '🇧🇦' },
  TZL: { city: 'Tuzla',                   flag: '🇧🇦' },

  // === NORTH MACEDONIA ===
  SKP: { city: 'Skopje',                  flag: '🇲🇰' },

  // === MONTENEGRO ===
  TGD: { city: 'Podgorica',               flag: '🇲🇪' },
  TIV: { city: 'Tivat',                   flag: '🇲🇪' },

  // === ALBANIA ===
  TIA: { city: 'Tirana',                  flag: '🇦🇱' },

  // === KOSOVO ===
  PRN: { city: 'Pristina',                flag: '🇽🇰' },

  // === LATVIA ===
  RIX: { city: 'Riga',                    flag: '🇱🇻' },

  // === LITHUANIA ===
  VNO: { city: 'Vilnius',                 flag: '🇱🇹' },
  KUN: { city: 'Kaunas',                  flag: '🇱🇹' },

  // === ESTONIA ===
  TLL: { city: 'Tallinn',                 flag: '🇪🇪' },

  // === MOLDOVA ===
  KIV: { city: 'Chișinău',               flag: '🇲🇩' },
  RMO: { city: 'Chișinău',               flag: '🇲🇩' },

  // === UKRAINE ===
  KBP: { city: 'Kyiv',                    flag: '🇺🇦' },
  LWO: { city: 'Lviv',                    flag: '🇺🇦' },

  // === GREECE ===
  ATH: { city: 'Athens',                  flag: '🇬🇷' },
  SKG: { city: 'Thessaloniki',            flag: '🇬🇷' },
  HER: { city: 'Heraklion',               flag: '🇬🇷' },
  CHQ: { city: 'Chania',                  flag: '🇬🇷' },
  RHO: { city: 'Rhodes',                  flag: '🇬🇷' },
  KGS: { city: 'Kos',                     flag: '🇬🇷' },
  CFU: { city: 'Corfu',                   flag: '🇬🇷' },
  ZTH: { city: 'Zakynthos',               flag: '🇬🇷' },
  JMK: { city: 'Mykonos',                 flag: '🇬🇷' },
  JTR: { city: 'Santorini',               flag: '🇬🇷' },

  // === TURKEY ===
  IST: { city: 'Istanbul',                flag: '🇹🇷' },
  SAW: { city: 'Istanbul Sabiha',         flag: '🇹🇷' },
  AYT: { city: 'Antalya',                 flag: '🇹🇷' },
  ADB: { city: 'İzmir',                  flag: '🇹🇷' },
  ESB: { city: 'Ankara',                  flag: '🇹🇷' },
  DLM: { city: 'Dalaman',                 flag: '🇹🇷' },
  BJV: { city: 'Bodrum',                  flag: '🇹🇷' },
  TZX: { city: 'Trabzon',                 flag: '🇹🇷' },

  // === CYPRUS ===
  LCA: { city: 'Larnaca',                 flag: '🇨🇾' },
  PFO: { city: 'Paphos',                  flag: '🇨🇾' },

  // === MALTA ===
  MLA: { city: 'Malta',                   flag: '🇲🇹' },

  // === POPULAR INTERNATIONAL DESTINATIONS ===
  DXB: { city: 'Dubai',                   flag: '🇦🇪' },
  AUH: { city: 'Abu Dhabi',               flag: '🇦🇪' },
  TLV: { city: 'Tel Aviv',                flag: '🇮🇱' },
  CMN: { city: 'Casablanca',              flag: '🇲🇦' },
  RAK: { city: 'Marrakech',               flag: '🇲🇦' },
  TUN: { city: 'Tunis',                   flag: '🇹🇳' },
  CAI: { city: 'Cairo',                   flag: '🇪🇬' },
  HRG: { city: 'Hurghada',                flag: '🇪🇬' },
  SSH: { city: 'Sharm el-Sheikh',         flag: '🇪🇬' },
  JFK: { city: 'New York',                flag: '🇺🇸' },
  LAX: { city: 'Los Angeles',             flag: '🇺🇸' },
  BKK: { city: 'Bangkok',                 flag: '🇹🇭' },
  SIN: { city: 'Singapore',               flag: '🇸🇬' },

  ALA: { city: 'Almaty',                  flag: '🇰🇿' },
  KZN: { city: 'Kazan',                   flag: '🇷🇺' },
  LXA: { city: 'Lhasa',                   flag: '🇨🇳' },

  // === EAST ASIA ===
  NRT: { city: 'Tokyo Narita',            flag: '🇯🇵' },
  KIX: { city: 'Osaka',                   flag: '🇯🇵' },
  FUK: { city: 'Fukuoka',                 flag: '🇯🇵' },
  CTS: { city: 'Sapporo',                 flag: '🇯🇵' },
  OKA: { city: 'Okinawa',                 flag: '🇯🇵' },
  ICN: { city: 'Seoul',                   flag: '🇰🇷' },
  TPE: { city: 'Taipei',                  flag: '🇹🇼' },
  HKG: { city: 'Hong Kong',               flag: '🇭🇰' },
  PEK: { city: 'Beijing',                 flag: '🇨🇳' },
  PVG: { city: 'Shanghai',                flag: '🇨🇳' },
  MFM: { city: 'Macau',                   flag: '🇲🇴' },
  ULN: { city: 'Ulaanbaatar',             flag: '🇲🇳' },

  // === SOUTH ASIA ===
  DEL: { city: 'New Delhi',               flag: '🇮🇳' },
  BOM: { city: 'Mumbai',                  flag: '🇮🇳' },
  BLR: { city: 'Bengaluru',               flag: '🇮🇳' },
  GOI: { city: 'Goa',                     flag: '🇮🇳' },
  COK: { city: 'Kochi',                   flag: '🇮🇳' },
  KTM: { city: 'Kathmandu',               flag: '🇳🇵' },
  CMB: { city: 'Colombo',                 flag: '🇱🇰' },
  MLE: { city: 'Malé',                    flag: '🇲🇻' },

  // === SOUTHEAST ASIA ===
  HKT: { city: 'Phuket',                  flag: '🇹🇭' },
  KUL: { city: 'Kuala Lumpur',            flag: '🇲🇾' },
  PEN: { city: 'Penang',                  flag: '🇲🇾' },
  LGK: { city: 'Langkawi',                flag: '🇲🇾' },
  BKI: { city: 'Kota Kinabalu',           flag: '🇲🇾' },
  DPS: { city: 'Bali',                    flag: '🇮🇩' },
  CGK: { city: 'Jakarta',                 flag: '🇮🇩' },
  SGN: { city: 'Ho Chi Minh City',        flag: '🇻🇳' },
  HAN: { city: 'Hanoi',                   flag: '🇻🇳' },
  DAD: { city: 'Da Nang',                 flag: '🇻🇳' },
  MNL: { city: 'Manila',                  flag: '🇵🇭' },
  REP: { city: 'Siem Reap',               flag: '🇰🇭' },
  PNH: { city: 'Phnom Penh',              flag: '🇰🇭' },
  RGN: { city: 'Yangon',                  flag: '🇲🇲' },
  VTE: { city: 'Vientiane',               flag: '🇱🇦' },
  LPQ: { city: 'Luang Prabang',           flag: '🇱🇦' },

  // === CENTRAL ASIA & CAUCASUS ===
  TAS: { city: 'Tashkent',                flag: '🇺🇿' },
  SKD: { city: 'Samarkand',               flag: '🇺🇿' },
  TBS: { city: 'Tbilisi',                 flag: '🇬🇪' },
  GYD: { city: 'Baku',                    flag: '🇦🇿' },
  IKA: { city: 'Tehran',                  flag: '🇮🇷' },

  // === MIDDLE EAST ===
  DOH: { city: 'Doha',                    flag: '🇶🇦' },
  AMM: { city: 'Amman',                   flag: '🇯🇴' },
  BEY: { city: 'Beirut',                  flag: '🇱🇧' },

  // === AFRICA ===
  FEZ: { city: 'Fez',                     flag: '🇲🇦' },
  AGA: { city: 'Agadir',                  flag: '🇲🇦' },
  DJE: { city: 'Djerba',                  flag: '🇹🇳' },
  ADD: { city: 'Addis Ababa',             flag: '🇪🇹' },
  DKR: { city: 'Dakar',                   flag: '🇸🇳' },
  ACC: { city: 'Accra',                   flag: '🇬🇭' },
  NBO: { city: 'Nairobi',                 flag: '🇰🇪' },
  MBA: { city: 'Mombasa',                 flag: '🇰🇪' },
  LOS: { city: 'Lagos',                   flag: '🇳🇬' },
  JNB: { city: 'Johannesburg',            flag: '🇿🇦' },
  CPT: { city: 'Cape Town',               flag: '🇿🇦' },
  DAR: { city: 'Dar es Salaam',           flag: '🇹🇿' },
  ZNZ: { city: 'Zanzibar',                flag: '🇹🇿' },
  MRU: { city: 'Mauritius',               flag: '🇲🇺' },

  // === OCEANIA ===
  SYD: { city: 'Sydney',                  flag: '🇦🇺' },
  MEL: { city: 'Melbourne',               flag: '🇦🇺' },
  AKL: { city: 'Auckland',                flag: '🇳🇿' },

  // === NORTH AMERICA ===
  YYZ: { city: 'Toronto',                 flag: '🇨🇦' },
  YVR: { city: 'Vancouver',               flag: '🇨🇦' },
  MIA: { city: 'Miami',                   flag: '🇺🇸' },
  ORD: { city: 'Chicago',                 flag: '🇺🇸' },
  SFO: { city: 'San Francisco',           flag: '🇺🇸' },

  // === CENTRAL AMERICA & CARIBBEAN ===
  MEX: { city: 'Mexico City',             flag: '🇲🇽' },
  CUN: { city: 'Cancún',                  flag: '🇲🇽' },
  HAV: { city: 'Havana',                  flag: '🇨🇺' },
  SDQ: { city: 'Santo Domingo',           flag: '🇩🇴' },
  SJO: { city: 'San José',               flag: '🇨🇷' },
  GUA: { city: 'Guatemala City',          flag: '🇬🇹' },

  // === SOUTH AMERICA ===
  GRU: { city: 'São Paulo',               flag: '🇧🇷' },
  GIG: { city: 'Rio de Janeiro',          flag: '🇧🇷' },
  EZE: { city: 'Buenos Aires',            flag: '🇦🇷' },
  SCL: { city: 'Santiago',                flag: '🇨🇱' },
  BOG: { city: 'Bogotá',                 flag: '🇨🇴' },
  MDE: { city: 'Medellín',               flag: '🇨🇴' },
  CTG: { city: 'Cartagena',              flag: '🇨🇴' },
  LIM: { city: 'Lima',                    flag: '🇵🇪' },
  UIO: { city: 'Quito',                   flag: '🇪🇨' },
  MVD: { city: 'Montevideo',              flag: '🇺🇾' },

  // === ADDITIONAL EUROPE ===
  BVA: { city: 'Paris Beauvais',          flag: '🇫🇷' },
  CIA: { city: 'Rome Ciampino',           flag: '🇮🇹' },
  NWI: { city: 'Norwich',                 flag: '🇬🇧' },
  LED: { city: 'Saint Petersburg',        flag: '🇷🇺' },
  VKO: { city: 'Moscow',                  flag: '🇷🇺' },
  MSQ: { city: 'Minsk',                   flag: '🇧🇾' },
  NOP: { city: 'Sinop',                   flag: '🇹🇷' },
  XWG: { city: 'Strasbourg',              flag: '🇫🇷' },
  GHV: { city: 'Brașov',                 flag: '🇷🇴' },
  ZSB: { city: 'Salzburg',                flag: '🇦🇹' },
}

// Maps flag emoji → country name — used by DealCard and the deal detail page
// to show e.g. "🇳🇱 Netherlands · AMS → 🇵🇹 Portugal · FAO" without repeating
// the country string once per AIRPORT_DB entry.
export const FLAG_COUNTRY = {
  '🇳🇱': 'Netherlands',
  '🇬🇧': 'United Kingdom',
  '🇮🇪': 'Ireland',
  '🇫🇷': 'France',
  '🇧🇪': 'Belgium',
  '🇱🇺': 'Luxembourg',
  '🇩🇪': 'Germany',
  '🇨🇭': 'Switzerland',
  '🇦🇹': 'Austria',
  '🇪🇸': 'Spain',
  '🇵🇹': 'Portugal',
  '🇮🇹': 'Italy',
  '🇩🇰': 'Denmark',
  '🇳🇴': 'Norway',
  '🇸🇪': 'Sweden',
  '🇫🇮': 'Finland',
  '🇮🇸': 'Iceland',
  '🇵🇱': 'Poland',
  '🇨🇿': 'Czech Republic',
  '🇸🇰': 'Slovakia',
  '🇭🇺': 'Hungary',
  '🇷🇴': 'Romania',
  '🇧🇬': 'Bulgaria',
  '🇷🇸': 'Serbia',
  '🇭🇷': 'Croatia',
  '🇸🇮': 'Slovenia',
  '🇧🇦': 'Bosnia',
  '🇲🇰': 'North Macedonia',
  '🇲🇪': 'Montenegro',
  '🇦🇱': 'Albania',
  '🇽🇰': 'Kosovo',
  '🇱🇻': 'Latvia',
  '🇱🇹': 'Lithuania',
  '🇪🇪': 'Estonia',
  '🇲🇩': 'Moldova',
  '🇺🇦': 'Ukraine',
  '🇬🇷': 'Greece',
  '🇹🇷': 'Turkey',
  '🇨🇾': 'Cyprus',
  '🇲🇹': 'Malta',
  '🇦🇪': 'UAE',
  '🇮🇱': 'Israel',
  '🇱🇧': 'Lebanon',
  '🇲🇦': 'Morocco',
  '🇹🇳': 'Tunisia',
  '🇪🇬': 'Egypt',
  '🇺🇸': 'United States',
  '🇹🇭': 'Thailand',
  '🇸🇬': 'Singapore',
  '🇰🇿': 'Kazakhstan',
  '🇷🇺': 'Russia',
  '🇨🇳': 'China',
  '🇯🇵': 'Japan',
  '🇰🇷': 'South Korea',
  '🇹🇼': 'Taiwan',
  '🇭🇰': 'Hong Kong',
  '🇲🇳': 'Mongolia',
  '🇲🇴': 'Macau',
  '🇮🇳': 'India',
  '🇳🇵': 'Nepal',
  '🇱🇰': 'Sri Lanka',
  '🇲🇻': 'Maldives',
  '🇲🇾': 'Malaysia',
  '🇮🇩': 'Indonesia',
  '🇻🇳': 'Vietnam',
  '🇵🇭': 'Philippines',
  '🇰🇭': 'Cambodia',
  '🇲🇲': 'Myanmar',
  '🇱🇦': 'Laos',
  '🇺🇿': 'Uzbekistan',
  '🇬🇪': 'Georgia',
  '🇦🇿': 'Azerbaijan',
  '🇮🇷': 'Iran',
  '🇶🇦': 'Qatar',
  '🇯🇴': 'Jordan',
  '🇪🇹': 'Ethiopia',
  '🇸🇳': 'Senegal',
  '🇬🇭': 'Ghana',
  '🇰🇪': 'Kenya',
  '🇳🇬': 'Nigeria',
  '🇿🇦': 'South Africa',
  '🇹🇿': 'Tanzania',
  '🇲🇺': 'Mauritius',
  '🇦🇺': 'Australia',
  '🇳🇿': 'New Zealand',
  '🇨🇦': 'Canada',
  '🇲🇽': 'Mexico',
  '🇨🇺': 'Cuba',
  '🇩🇴': 'Dominican Republic',
  '🇨🇷': 'Costa Rica',
  '🇬🇹': 'Guatemala',
  '🇧🇷': 'Brazil',
  '🇦🇷': 'Argentina',
  '🇨🇱': 'Chile',
  '🇨🇴': 'Colombia',
  '🇵🇪': 'Peru',
  '🇪🇨': 'Ecuador',
  '🇺🇾': 'Uruguay',
  '🇧🇾': 'Belarus',
}
